import { render, staticRenderFns } from "./SendModeSetting.vue?vue&type=template&id=534fd4e8&scoped=true&"
import script from "./SendModeSetting.vue?vue&type=script&lang=ts&"
export * from "./SendModeSetting.vue?vue&type=script&lang=ts&"
import style0 from "./SendModeSetting.vue?vue&type=style&index=0&id=534fd4e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534fd4e8",
  null
  
)

export default component.exports